export const DBA_TYPES_RESET_STATE = 'DBA_TYPES_RESET_STATE';
export const DBA_TYPES_CURRENT_ITEM = 'DBA_TYPES_CURRENT_ITEM';

export const DBA_TYPES_REQUEST_LOADING = 'DBA_TYPES_REQUEST_LOADING';
export const DBA_TYPES_REQUEST_SUCCESS = 'DBA_TYPES_REQUEST_SUCCESS';
export const DBA_TYPES_REQUEST_FAILED = 'DBA_TYPES_REQUEST_FAILED';

export const DBA_TYPES_CURRENT_ACTION = 'DBA_TYPES_CURRENT_ACTION';
export const DBA_TYPES_RESET_ACTION = 'DBA_TYPES_RESET_ACTION';